'use client'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { SeoHeadTitleMetas } from '../../seo'
import { StandardShopLayout } from '../../standard-shop-layout'

import { OtherTopicsContactHeader } from './OtherTopicsContactHeader'
import { OtherTopicsContactPageOptions } from './OtherTopicsContactPageOptions'
import { type OtherTopicsContactProps } from './OtherTopicsContactProps'

export const OtherTopicsContactClientPage: FC<OtherTopicsContactProps> = ({
  standardLayoutData,
}) => {
  const intl = useIntl()
  const title = intl.formatMessage({ id: 'help.centre.others.options.title' })

  return (
    <StandardShopLayout standardLayoutData={standardLayoutData}>
      <main>
        <SeoHeadTitleMetas title={title} />
        <div className="bg-light-primary-medium py-6 tablet:py-11">
          <OtherTopicsContactHeader />
          <OtherTopicsContactPageOptions />
        </div>
      </main>
    </StandardShopLayout>
  )
}
